import React, { useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { TextField, Link, Icon } from '@fluentui/react';
import './Search.scss';
import { Text } from '@fluentui/react';

import { Link as LinkRoute } from 'react-router-dom';
import SearchSuggestion from './searchSuggestion/SearchSuggestion';
import { useSearchData, useAutoSearch } from 'app/services/search-api';
import { useGetWebSearchLinks, useSpeechToTextToken, useGetIntranetSearchLinks } from 'app/services/search-api';
import { SearchOption, SharepointSearchResponse, SuggestDocument, SuggestResponse, WebSearchResponse } from 'generated/search-backend';
import { changeDateFormat, getIcon, keyPress } from 'app/components/helpers';
import useStore, { IStore } from 'app/store';
import { Trans } from 'react-i18next';
import { setTimeout } from 'timers';
import { debounce } from 'lodash';
import { appInsightsService } from 'app/utils/constants';
import { isQuotedPhrase, SEARCH_PLACEHOLDERS } from 'app/utils/searchUtilities';
import * as speechSdk from 'microsoft-cognitiveservices-speech-sdk';
import SearchInDropdown, { getSearchFieldParams } from 'app/components/searchInDropdown/SearchInDropdown';


const Search: React.FC<{ showFieldSelector?: boolean, onInputFocus?: () => void, onInputBlur?: () => void }> = ({ showFieldSelector, onInputFocus, onInputBlur }) => {
    const setUserSearchValue = useStore((state: IStore) => state.setUserSearchValue);
    const userSearchValue = useStore((state: IStore) => state.userSearchValue);
    const searchInFields = useStore((state: IStore) => state.searchInFields);
    const setSearchInFields = useStore((state: IStore) => state.setSearchInFields);

    //location
    let history = useHistory();
    let location = useLocation();

    const [searchResult, setSearchResult] = useState<SuggestResponse[]>([]);

    const [openTickets, setOpenTickets] = useState<SuggestDocument[]>([]);
    const [resolvedTickets, setResolvedTickets] = useState<SuggestDocument[]>([]);
    const { mutate: searchData, data: searchResultData, isSuccess: isSuccessSearch } = useSearchData();

    const [autoSearch, setAutoSearch] = useState([]);
    //auto suggest
    const {
        mutate: autoSearchData,
        data: autoSearchResultData,
        isSuccess: isAutoSuccessSearch,
        isError: isAutoErrorSearch,
        isLoading: isAutoLoadingSearch
    } = useAutoSearch();

    useEffect(() => {
        return () => {
            setUserSearchValue('');
        };
    }, []);

    useEffect(() => {
        if (isAutoSuccessSearch && !isAutoLoadingSearch) {
            setAutoSearch(autoSearchResultData);
            const candidate =
                autoSearchResultData && autoSearchResultData.length ? autoSearchResultData[0] : '';
            if (
                candidate &&
                tempInputValue &&
                candidate.toLowerCase().startsWith(tempInputValue.toLowerCase())
            ) {
                setAutoSuggestValue(candidate);
            } else {
                setAutoSuggestValue('');
            }
        }
        if (isAutoErrorSearch && !isAutoLoadingSearch) {
            setAutoSuggestValue('');
        }
    }, [isAutoSuccessSearch, autoSearchResultData, isAutoErrorSearch, isAutoLoadingSearch]);

    useEffect(() => {
        if (isSuccessSearch) {
            setSearchResult(searchResultData);

            let openTicket: SuggestDocument[] = [];
            let resolvedTicket: SuggestDocument[] = [];
            searchResultData.forEach((item: SuggestResponse) => {
                if (item.document?.resultType === 'Ticket') {
                    if (item.document?.status === 1 || item.document?.status === 2 || item.document?.status === 3) {
                        openTicket.push(item.document);
                    } else if (item.document?.status === 4) {
                        resolvedTicket.push(item.document);
                    }
                }
            });

            setOpenTickets(openTicket);
            setResolvedTickets(resolvedTicket);

            let tagsApi = searchResultData;
            let tagsArray = new Set<string>();

            tagsApi?.forEach((item: SuggestResponse) => {
                item.document?.keyphrases.forEach((i: string) => {
                    tagsArray.add(i);
                });
            });

            setTags(Array.from(tagsArray));
        }
    }, [isSuccessSearch]);

    useEffect(() => {
        if (userSearchValue) {
            setInputValue(userSearchValue);
            if (tempInputValue !== userSearchValue) {
                setTempInputValue(userSearchValue);
            }
        }
    }, [userSearchValue]);

    const { refetch: getSpeechToTextToken } = useSpeechToTextToken();

    const [isRecording, setIsRecording] = useState(false);

    const [recognizer, setRecognizer] = useState(null);
    //voice to text
    const sttFromMic = async (action: Boolean) => {
        if (action) {
            try {
                let token = JSON.parse(sessionStorage.getItem('speech-token'));
                if (!(token && token.Token)) {
                    await getSpeechToTextToken();
                    token = JSON.parse(sessionStorage.getItem('speech-token'));
                }
            const speechConfig = speechSdk.SpeechConfig.fromAuthorizationToken(token?.Token ?? '', token?.Region ?? '');
            speechConfig.speechRecognitionLanguage = 'en-US';
            speechConfig.setServiceProperty('punctuation', 'explicit', speechSdk.ServicePropertyChannel.UriQueryParameter);
            // speechConfig.enableDictation();
            const audioConfig = speechSdk.AudioConfig.fromDefaultMicrophoneInput();
            let newRecognizer = new speechSdk.SpeechRecognizer(speechConfig, audioConfig);
            setRecognizer(newRecognizer);
            setIsRecording(true);
            newRecognizer.recognized = function (s: speechSdk.Recognizer, e: speechSdk.SpeechRecognitionEventArgs) {
                let displayText;

                if (e.result.text) {
                    displayText = `${e.result.text}`;
                    displayText = displayText.replace('SKP ', 'SKP-');
                    //displayText = displayText.substring(0, displayText.length - 1);
                    setInputValue(displayText);
                    setUserSearchValue(displayText);
                    searchData({
                        term: displayText,
                        searchOption: SearchOption.Default,
                        isAdminSearch: false,
                        isParentChildSearch: false,
                        customSearchFields: getSearchFieldParams(searchInFields).customSearchFields
                    });
                    setIsRecording(false);

                    if (displayText.length > 5 && !location.pathname.includes('/searchResult')) {
                        setShowSuggestion(true);
                    }
                    newRecognizer.stopContinuousRecognitionAsync(
                        () => { },
                        (e: string) => { }
                    );
                }
            };

            newRecognizer.startContinuousRecognitionAsync(() => {
                setTimeout(() => {
                    newRecognizer.stopContinuousRecognitionAsync(
                        () => { },
                        (e: string) => { }
                    );
                    setIsRecording(false);
                }, 20000);
            });

            ref.current.focus();
            } catch (e) {
                console.error('Speech recognition failed to initialize:', e);
                setIsRecording(false);
            }
        }

        if (!action) {
            recognizer.stopContinuousRecognitionAsync(
                (result: string) => { },
                (e: string) => { }
            );
        }
    };

    //local values
    const [showQuick, setShowQuick] = useState(false);
    const [showSuggestion, setShowSuggestion] = useState(false);
    const [tempInputValue, setTempInputValue] = useState(userSearchValue);
    const [inputValue, setInputValue] = useState(userSearchValue);
    const [searchWidth, setSearchWidth] = useState(false);
    const [isSearchInProgress, setIsSearchInProgress] = useState(false);
    const { data: webSearchData, isSuccess: webSearchLinksLoaded } = useGetWebSearchLinks(inputValue);
    const { data: intranetSearchData, isSuccess: intranetSearchLinksLoaded } = useGetIntranetSearchLinks(inputValue);

    //tags
    const [tags, setTags] = useState([]);

    //autosuggest
    const [autoSuggestValue, setAutoSuggestValue] = useState('');
    //search input value change
    const onChange = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        //setTempInputValue(event.target.value);

        if ((event.target as HTMLInputElement).value.length > 2) {
            setInputValue((event.target as HTMLInputElement).value);

            setShowSuggestion(true);
            if ((event.target as HTMLInputElement).value[(event.target as HTMLInputElement).value.length - 1] !== ' ') {
                searchData({
                    term: (event.target as HTMLInputElement).value?.trim(),
                    searchOption: SearchOption.Default,
                    isAdminSearch: false,
                    isParentChildSearch: false,
                    customSearchFields: getSearchFieldParams(searchInFields).customSearchFields
                });
                autoSearchData({
                    term: (event.target as HTMLInputElement).value?.trim(),
                    customSearchFields: getSearchFieldParams(searchInFields).customSearchFields
                });
            }

            setUserSearchValue((event.target as HTMLInputElement).value);
        } else {
            setAutoSuggestValue('');
        }
    };

    const debouncedFunction = useMemo(() => debounce(onChange, 300), [searchInFields]);
    useEffect(() => () => debouncedFunction.cancel(), [debouncedFunction]);

    const debouncedChangeHandler = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newValue = (event.target as HTMLInputElement | HTMLTextAreaElement).value;
        setTempInputValue(newValue);
        if (autoSuggestValue && !autoSuggestValue.toLowerCase().startsWith(newValue.toLowerCase())) {
            setAutoSuggestValue('');
        }
        debouncedFunction(event);
    };

    //search input on focus
    const inputFocus = () => {
        setShowQuick(!showQuick);
        setSearchWidth(true);
        // log the search bar focus event
        appInsightsService.logEvent("SearchBarFocus: focused on search bar");
    };

    //search input on blur
    const handleSuggestionClose = () => {
        setShowQuick(!showQuick);
        setSearchWidth(false);
        setShowSuggestion(false);
    };

    const keydown = (e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        /* 
        don't delete this for tab auto suggest
        if (e.keyCode === 9 && inputValue.trim()) {
            setInputValue(autoSearch && autoSearch.length ? autoSearch[0] : '');
        } */
        if (inputValue.length <= 0) {
            setAutoSuggestValue('');
        }
        // log the search initiation event
        // log only one time when the search is initiated
        if(!isSearchInProgress){
            setIsSearchInProgress(true);
            appInsightsService.logEvent("SearchInitiated: initiated a search");
        }
    };

    //search input key up
    const keyUp = (e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>, isPaste: boolean) => {
        if (inputValue.length > 2) {
            setShowSuggestion(true);
        }

        if (inputValue.length <= 0) {
            setAutoSuggestValue('');
        }

        if (autoSearch && autoSearch.length <= 0) {
            setAutoSuggestValue('');
        }

        if (
            (e.code === 'Enter' || e.code === 'NumpadEnter') &&
            !location.pathname.includes('search-results') &&
            inputValue.trim().length > 2 &&
            (e.target as HTMLInputElement | HTMLTextAreaElement).value.trim().length > 2
        ) {
            history.push('/search-results');
            // log the search submission event
            appInsightsService.logEvent("SearchSubmission: Submitted search", {
                phraseMatch: String(isQuotedPhrase(inputValue))
            });
        } else if (
            (e.code === 'Enter' || e.code === 'NumpadEnter') &&
            location.pathname.includes('search-results') &&
            inputValue.trim().length > 2 &&
            (e.target as HTMLInputElement | HTMLTextAreaElement).value.trim().length > 2
        ) {
            history.push('search-results');
            setUserSearchValue((e.target as HTMLInputElement | HTMLTextAreaElement).value);
            setShowSuggestion(false);
            // log the search submission event
            appInsightsService.logEvent("SearchSubmission: Submitted search", {
                phraseMatch: String(isQuotedPhrase((e.target as HTMLInputElement | HTMLTextAreaElement).value))
            });
        }
    };

    const logSearchResultClick = (id: string, index: number) => {
        // Function to log the search result click event
        // This is implemented to track user interactions with search results
        appInsightsService.logEvent("SearchResultClick: clicked a search result", {
            searchResultId: id,
            index: index?.toString()
        });
    };

    const voiceSearchOn = () => {
        sttFromMic(true);
        setSearchWidth(true);
        if(!isSearchInProgress){
            setIsSearchInProgress(true);
            appInsightsService.logEvent("VoiceSearchInitiated: initiated a voice search");
        }
    };

    const voiceSearchOff = () => {
        setIsRecording(false);
        sttFromMic(false);
        setIsSearchInProgress(false);
        appInsightsService.logEvent("VoiceSearchEnded: ended the voice search");
    };

    //on tag click
    const tagClick = (search: string) => {
        setInputValue(search);
        setTempInputValue(search);
        searchData({
            term: search,
            searchOption: SearchOption.Default,
            isAdminSearch: false,
            isParentChildSearch: false,
            customSearchFields: getSearchFieldParams(searchInFields).customSearchFields
        });
        setTimeout(function () {
            setSearchWidth(true);
            setShowSuggestion(true);
        }, 200);

        ref.current.focus();
    };
    const inputBlur = () => {
        setAutoSuggestValue('');
        setIsSearchInProgress(false);
        appInsightsService.logEvent("SearchEnded: ended the search");
    };

    // Treat the portaled SearchInDropdown menu (`.search-in-menu`) as part of the
    // search interaction so clicking the field-selector trigger or a menu item does
    // not collapse the field selector while the user is still operating it.
    const isWithinSearchInteraction = (target: EventTarget | null) => {
        if (!(target instanceof Element)) return false;
        if (searchContainer.current?.contains(target)) return true;
        return !!target.closest('.search-in-menu');
    };

    const handleContainerFocus = () => {
        onInputFocus?.();
    };

    const handleContainerBlur = (e: React.FocusEvent<HTMLDivElement>) => {
        if (isWithinSearchInteraction(e.relatedTarget)) return;
        onInputBlur?.();
    };

    //calling custom hook
    const searchContainer = useRef<HTMLDivElement>(null);
    useSearchSuggestionClose(searchContainer, handleSuggestionClose);

    //input on paste
    const onPaste = (e: React.ClipboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        onChange(e);

        if (inputValue.length > 2) {
            setShowSuggestion(true);
        }
    };

    const ref = useRef(null);

    return (
        <div className={`search-container ${searchWidth ? 'search-width' : ''}`} ref={searchContainer} onFocus={handleContainerFocus} onBlur={handleContainerBlur}>
            <div className={`search-box ${showSuggestion ? 'suggest-show' : ''}`}>
                <div className="search-typeahead">
                    {showFieldSelector && (
                        <>
                            <SearchInDropdown
                                values={searchInFields}
                                onChange={(vals) => setSearchInFields(vals)}
                                className="search-bar-field-selector"
                            />
                            <div className="search-in-divider" />
                        </>
                    )}
                    <div className="search-input-wrap">
                        <TextField
                            tabIndex={0}
                            onFocus={() => inputFocus()}
                            onBlur={() => inputBlur()}
                            value={tempInputValue}
                            //onChange={onChange}
                            onChange={debouncedChangeHandler}
                            onKeyUp={(e) => keyUp(e, false)}
                            className={`search-input ${tempInputValue.length === 0 ? 'search-input-icon' : ''}`}
                            autoComplete={'off'}
                            onPaste={(e) => onPaste(e)}
                            onKeyDown={keydown}
                            placeholder={SEARCH_PLACEHOLDERS.homepage}
                            componentRef={ref}
                        />
                        {tempInputValue !== '' &&
                            autoSuggestValue.length > tempInputValue.length &&
                            autoSuggestValue.toLowerCase().startsWith(tempInputValue.toLowerCase()) && (
                                <div className="auto-suggest-text" aria-hidden="true">
                                    <span className="auto-suggest-typed">{tempInputValue}</span>
                                    <span className="auto-suggest-completion">
                                        {autoSuggestValue.substring(tempInputValue.length)}
                                    </span>
                                </div>
                            )}
                    </div>
                    {tempInputValue.length === 0 && autoSuggestValue.length === 0 && (
                        <Icon className="placeholder-search-icon" iconName="Search" />
                    )}

                    {isRecording && (
                        <div
                            className="recording-row recording-position"
                            tabIndex={0}
                            onKeyPress={(e) => keyPress(e, () => voiceSearchOff())}
                            onClick={() => voiceSearchOff()}>
                            <div className="first-line"></div>
                            <div className="second-line"></div>
                            <div className="third-line"></div>
                            <div className="fourth-line"></div>
                            <div className="fifth-line"></div>
                        </div>
                    )}
                    {!isRecording && (
                        <i
                            className="micro-icon"
                            tabIndex={0}
                            onKeyPress={(e) => keyPress(e, () => voiceSearchOn())}
                            onClick={() => voiceSearchOn()}
                            aria-label="voice-icon"
                            role="button"></i>
                    )}
                </div>
            </div>

            <div>
                {showSuggestion &&
                    ((searchResult && searchResult.length > 0) || (intranetSearchData && intranetSearchData.length > 0)) && (
                        <div className="search-results-suggestion">
                            <div className="grid-box">
                                <div className="grid-left">
                                    <ul className="chips-container">
                                        {isSuccessSearch &&
                                            tags.length > 0 &&
                                            tags.slice(0, 10).map((tag: string, idx: number) => (
                                                <li key={idx}>
                                                    <span
                                                        tabIndex={0}
                                                        onKeyPress={(e) => keyPress(e, () => tagClick(tag))}
                                                        onClick={() => tagClick(tag)}
                                                        className="chip-item">
                                                        {tag}
                                                    </span>
                                                </li>
                                            ))}
                                    </ul>

                                    {isSuccessSearch &&
                                        searchResult.length > 0 &&
                                        searchResult
                                            .filter((item: SuggestResponse) => item.document?.resultType === 'Article')
                                            .map((item: SuggestResponse, idx: number) => (
                                                <SearchSuggestion key={idx} listData={item.document} onClick={() => logSearchResultClick(item?.document?.id, idx)} />
                                            ))}

                                    {intranetSearchLinksLoaded && intranetSearchData?.length > 0 && (
                                        <div className="request-container">
                                            <h6>
                                                <Trans>FROM THE INTRANET</Trans>
                                            </h6>

                                            {intranetSearchData?.map((item: SharepointSearchResponse, idx: number) => {
                                                return (
                                                    <div key={idx} className="request-links-container col-flex-box">
                                                        <Text className="request-links">
                                                            <span className={getIcon(item?.name)}></span>
                                                            <Link role="link" href={`${item?.url}`} target="_blank" onClick={() => logSearchResultClick(item?.url, idx)}>
                                                                {item?.name?.split('.')[0]}
                                                            </Link>
                                                        </Text>
                                                        <Text className="webSearch-snippet">{item?.snippet} </Text>
                                                        <Link className="des-text" href={`${item?.url}`} target="_blank">
                                                            {item?.url}
                                                        </Link>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>
                                {isSuccessSearch && searchResult.length > 0 && (
                                    <div className="grid-right">
                                        {openTickets.length > 0 && (
                                            <div className="request-container">
                                                <h6>
                                                    <Trans>Open Requests</Trans>
                                                </h6>
                                                <div>
                                                    {isSuccessSearch &&
                                                        openTickets.map((item: SuggestDocument, idx: number) => {
                                                            return (
                                                                <div key={idx} className="request-links-container">
                                                                    <Text className="request-links">
                                                                        <LinkRoute
                                                                            role="link"
                                                                            to={`/request/${item.unifiedTrackingId}`}
                                                                            tabIndex={0}
                                                                            onClick={() => logSearchResultClick(item?.unifiedTrackingId, idx)}
                                                                        >
                                                                            {item.unifiedTrackingId} - {item.title}
                                                                        </LinkRoute>
                                                                    </Text>
                                                                    <Text className="des-text">
                                                                        <Trans>Requested by</Trans> {item.createdBy?.displayName}{' '}
                                                                        on {changeDateFormat(item.createdOn, 'MMMM DD, YYYY')}
                                                                    </Text>
                                                                </div>
                                                            );
                                                        })}
                                                </div>
                                            </div>
                                        )}

                                        {resolvedTickets && resolvedTickets.length > 0 && (
                                            <div className="request-container">
                                                <h6>
                                                    <Trans>Resolved Requests</Trans>
                                                </h6>
                                                {isSuccessSearch &&
                                                    resolvedTickets.length > 0 &&
                                                    resolvedTickets.map((item: SuggestDocument, idx: number) => {
                                                        return (
                                                            <div key={idx} className="request-links-container">
                                                                <Text className="request-links">
                                                                    <LinkRoute
                                                                        role="link"
                                                                        to={`/request/${item.unifiedTrackingId}`}
                                                                        onClick={() => logSearchResultClick(item?.unifiedTrackingId, idx)}
                                                                    >
                                                                        {item.unifiedTrackingId} - {item.title}
                                                                    </LinkRoute>
                                                                </Text>
                                                                <Text className="des-text">
                                                                    <Trans>Requested by</Trans> {item.createdBy?.displayName} on{' '}
                                                                    {changeDateFormat(item.createdOn, 'MMMM DD, YYYY')}
                                                                </Text>
                                                            </div>
                                                        );
                                                    })}
                                            </div>
                                        )}
                                        {webSearchLinksLoaded && webSearchData?.length > 0 && (
                                            <div className="request-container">
                                                <h6>
                                                    <Trans>FROM THE WEB</Trans>
                                                </h6>

                                                {webSearchData?.map((item: WebSearchResponse, idx: number) => {
                                                    return (
                                                        <div key={idx} className="request-links-container col-flex-box">
                                                            <Text className="request-links">
                                                                <Link role="link" href={`${item?.url}`} target="_blank" onClick={() => logSearchResultClick(item?.url, idx)}>
                                                                    {item?.name}
                                                                </Link>
                                                            </Text>
                                                            <Text className="webSearch-snippet">{item?.snippet} </Text>
                                                            <Link className="des-text" href={`${item?.url}`} target="_blank" onClick={() => logSearchResultClick(item?.url, idx)}>
                                                                {item?.url}
                                                            </Link>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
            </div>
        </div>
    );
};

/**
 * This Hook handles closing the useSearchSuggestionClose  on clicking outside of the useSearchSuggestion container
 */
const useSearchSuggestionClose = (ref: React.MutableRefObject<HTMLDivElement>, handleSuggestionClose: Function) => {
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                handleSuggestionClose();
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [handleSuggestionClose, ref]);
};

export default Search;
